export const marketingTemplateTypes = Object.freeze({
  SMS: 'SMS',
  EMAIL: 'EMAIL',
});

export const campaignTypes = Object.freeze({
  FOLLOWUP: 'FOLLOWUP',
  PROMOTIONAL: 'PROMOTIONAL',
});

export const emailTemplateTypes = Object.freeze({
  DEFAULT: 'DEFAULT',
  ANNOUNCEMENT: 'ANNOUNCEMENT',
  PRODUCT_SERVICES: 'PRODUCT_SERVICES',
  NEWSLETTER: 'NEWSLETTER',
  FESTIVE: 'FESTIVE',
  CLASSIC: 'CLASSIC',
  MODERN: 'MODERN',
});

export const followUpEvents = Object.freeze({
  SEND_ESTIMATE: 'SEND_ESTIMATE',
  RO_INVOICED: 'RO_INVOICED',
  RO_FULL_PAID: 'RO_FULL_PAID',
  CUSTOMER_SAVE: 'CUSTOMER_SAVE',
  VEHICLE_SAVE: 'VEHICLE_SAVE',
});

export const followUpEventList = [
  { name: 'Send estimate', value: followUpEvents.SEND_ESTIMATE },
  { name: 'RO invoiced', value: followUpEvents.RO_INVOICED },
  { name: 'RO full paid', value: followUpEvents.RO_FULL_PAID },
  { name: 'Customer created', value: followUpEvents.CUSTOMER_SAVE },
  { name: 'Vehicle created', value: followUpEvents.VEHICLE_SAVE },
];

export const followUpEventTags = Object.freeze({
  [followUpEvents.SEND_ESTIMATE]: [
    { label: 'Estimate send date', value: '[estimate_send_date]' },
    { label: 'Vehicle YMM', value: '[vehicle_ymm]' },
    { label: 'RO #', value: '[ro_code]' },
    { label: 'RO name', value: '[ro_name]' },
  ],
  [followUpEvents.RO_INVOICED]: [
    { label: 'RO invoice date', value: '[ro_invoice_date]' },
    { label: 'Vehicle YMM', value: '[vehicle_ymm]' },
    { label: 'Deferred service link', value: '[deferred_service_link]' },
    { label: 'RO #', value: '[ro_code]' },
    { label: 'RO name', value: '[ro_name]' },
  ],
  [followUpEvents.RO_FULL_PAID]: [
    { label: 'RO invoice date', value: '[ro_invoice_date]' },
    { label: 'Vehicle YMM', value: '[vehicle_ymm]' },
    { label: 'Deferred service link', value: '[deferred_service_link]' },
    { label: 'RO #', value: '[ro_code]' },
    { label: 'RO name', value: '[ro_name]' },
  ],
  [followUpEvents.CUSTOMER_SAVE]: [{ label: 'Customer creation date', value: '[customer_creation_date]' }],
  [followUpEvents.VEHICLE_SAVE]: [
    { label: 'Vehicle YMM', value: '[vehicle_ymm]' },
    { label: 'Customer creation date', value: '[customer_creation_date]' },
    { label: 'Vehicle creation date', value: '[vehicle_creation_date]' },
  ],
});

export const smartFieldList = [
  '[estimate_send_date]',
  '[vehicle_ymm]',
  '[ro_code]',
  '[ro_name]',
  '[ro_invoice_date]',
  '[deferred_service_link]',
  '[customer_creation_date]',
  '[vehicle_creation_date]',
];

export const followUpCampaignStatus = Object.freeze({
  // Any saved campaign that has not been made live
  DRAFT: 'DRAFT',
  // Campaign that is scheduled to be released but haven't been released so far
  LIVE: 'LIVE',
  // Campaign that has been launched but has not passed its End date
  PAUSE: 'PAUSE',
  // Campaign that has been passed its End date
  ARCHIVED: 'ARCHIVED',
});

export const marketingBasicTags = {
  customerFirstName: '[[CUSTOMER_FIRST_NAME]]',
  customerLastName: '[[CUSTOMER_LAST_NAME]]',
  shopName: '[[SHOP_NAME]]',
  contactNumber: '[[SHOP_CONTACT_NUMBER]]',
};

export const followUpSheduleStatus = Object.freeze({
  scheduled: 'SCHEDULED',
  stop: 'STOPPED',
});
